import Image from 'next/image'
import Link from 'next/link'
import React from 'react'

export interface IAContactCard {
	image: string
	bgClass: string
	type: string
	title: string
	tel?: string
	email: string
	telHref?: string
	emailHref: string
	className?: string
}

const AContactCard: React.FC<IAContactCard> = ({
	image,
	bgClass,
	type,
	title,
	tel,
	email,
	telHref,
	emailHref,
	className = ''
}) => {
	return (
		<article className={`item_contact h-full flex flex-col ${className}`}>
			<div
				className='item_contact_image'
				style={{ position: 'relative', width: '100%', aspectRatio: '316/224' }}
			>
				<Image
					src={image}
					alt={title}
					fill
					style={{ objectFit: 'cover' }}
					unoptimized={true}
				/>
			</div>

			<div className={`item_contact_inner ${bgClass} flex-1 flex flex-col justify-between`}>
				<div className='item_contact_type'>{type}</div>

				<h3 className='item_contact_title'>{title}</h3>

				<div className='item_contact_bottom cursornodrag'>
					<div className='item_contact_cont'>
						{tel && (
							<Link
								href={telHref || '#'}
								title={tel}
								className='py-1'
								prefetch={false}
							>
								{tel}
							</Link>
						)}
						<Link href={emailHref} title={email} className='py-1' prefetch={false}>
							{email}
						</Link>
					</div>
				</div>
			</div>
		</article>
	)
}

export default AContactCard
